import React from "react";

import styled from "@emotion/styled";
import { color, typography, space, layout, variant } from "styled-system";

import { lightBlue } from "./colors";

const variants = {
  blueMedium: {
    fontSize: 30,
    color: lightBlue,
  },
  small: {
    textTransform: "none",
  },
};

const HeadingBase = ({ level, as: Component = level, ...props }) => (
  <Component {...props} />
);

const Heading = styled(HeadingBase)`
  font-family: "Quicksand", sans-serif;
  text-transform: uppercase;
  line-height: 1.1;
  font-weight: 700;

  ${variant({ variants })}
  ${color}
  ${typography}
  ${space}
  ${layout}
`;

export default Heading;
